import React, { useState, useRef, useEffect } from 'react';
import {PAGES} from "../constants";
import LoadingPage from "../Pages/LoadingPage";
import CongratulationsPage from "../Pages/CongratulationsPage";
import PersonalDetailsPage from "../Pages/PersonalDetailsPage";
import ClientDetailsPage from "../Pages/ClientDetailsPage";
import IsaDetailsPage from "../Pages/IsaDetailsPage";
import DeclarationPage from "../Pages/DeclarationPage";
import BankDetailsPage from "../Pages/BankDetailsPage";
import TaxInformationPage from "../Pages/TaxInformationPage";
import ReviewApplicationPage from "../Pages/ReviewApplicationPage";
import InformationCertificationAgreementsPage from "../Pages/InformationCertificationAgreementsPage";

const CustomerJourney = (props) => {
    /*
     * Stages:
     * 1.  Loading
     * 2.  Personal details
     * 3.  Client details
     * 4.  ISA details
     * 5.  Declaration
     * 6.  Bank details
     * 7.  Tax details.
     * 8.  Review application
     * 9.  Information, certification & agreement
     * 10. Congratulations
     */

    const [currentPage, setCurrentPage] = useState(PAGES.LOADING);

    useEffect(() => {
        customerPageDetails();
    }, []);

    const customerPageDetails = () => {
        axios.get(route('web-api.session.page-details.get', {session: window.session}).toString())
            .then((response) => {
                if (!!response && !!response.data) {
                    if (!!response.data.current_page) {
                        setCurrentPage(response.data.current_page);
                    }
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const previousPage = () => {
        switch (currentPage) {
            case PAGES.PERSONAL_DETAILS:
                // Start of journey
                break;
            case PAGES.CLIENT_DETAILS:
                setCurrentPage(PAGES.PERSONAL_DETAILS);
                break;
            case PAGES.ISA_DETAILS:
                setCurrentPage(PAGES.CLIENT_DETAILS);
                break;
            case PAGES.DECLARATION:
                setCurrentPage(PAGES.ISA_DETAILS);
                break;
            case PAGES.BANK_DETAILS:
                setCurrentPage(PAGES.DECLARATION);
                break;
            case PAGES.TAX_DETAILS:
                setCurrentPage(PAGES.BANK_DETAILS);
                break;
            case PAGES.REVIEW_APPLICATION:
                setCurrentPage(PAGES.TAX_DETAILS);
                break;
            case PAGES.INFORMATION_CERTIFICATION_AGREEMENT:
                setCurrentPage(PAGES.REVIEW_APPLICATION);
                break;
            case PAGES.CONGRATULATIONS:
                // End of journey
                break;
        }
    }

    const nextPage = () => {
        switch (currentPage) {
            case PAGES.PERSONAL_DETAILS:
                setCurrentPage(PAGES.CLIENT_DETAILS);
                break;
            case PAGES.CLIENT_DETAILS:
                setCurrentPage(PAGES.ISA_DETAILS);
                break;
            case PAGES.ISA_DETAILS:
                setCurrentPage(PAGES.DECLARATION);
                break;
            case PAGES.DECLARATION:
                setCurrentPage(PAGES.BANK_DETAILS);
                break;
            case PAGES.BANK_DETAILS:
                setCurrentPage(PAGES.TAX_DETAILS);
                break;
            case PAGES.TAX_DETAILS:
                setCurrentPage(PAGES.REVIEW_APPLICATION);
                break;
            case PAGES.REVIEW_APPLICATION:
                setCurrentPage(PAGES.INFORMATION_CERTIFICATION_AGREEMENT);
                break;
            case PAGES.INFORMATION_CERTIFICATION_AGREEMENT:
                setCurrentPage(PAGES.CONGRATULATIONS);
                break;
            case PAGES.CONGRATULATIONS:
                // End of journey
                break;
        }
    }

    const renderPage = () => {
        switch (currentPage) {
            case PAGES.LOADING:
                return (
                    <LoadingPage
                        nextPage={() => nextPage()}
                    />
                );
            case PAGES.PERSONAL_DETAILS:
                return (
                    <PersonalDetailsPage
                        nextPage={() => nextPage()}
                    />
                );
            case PAGES.CLIENT_DETAILS:
                return (
                    <ClientDetailsPage
                        previousPage={() => previousPage()}
                        nextPage={() => nextPage()}
                    />
                );
            case PAGES.ISA_DETAILS:
                return (
                    <IsaDetailsPage
                        previousPage={() => previousPage()}
                        nextPage={() => nextPage()}
                    />
                );
            case PAGES.DECLARATION:
                return (
                    <DeclarationPage
                        previousPage={() => previousPage()}
                        nextPage={() => nextPage()}
                    />
                );
            case PAGES.BANK_DETAILS:
                return (
                    <BankDetailsPage
                        previousPage={() => previousPage()}
                        nextPage={() => nextPage()}
                    />
                );
            case PAGES.TAX_DETAILS:
                return (
                    <TaxInformationPage
                        previousPage={() => previousPage()}
                        nextPage={() => nextPage()}
                    />
                );
            case PAGES.REVIEW_APPLICATION:
                return (
                    <ReviewApplicationPage
                        previousPage={() => previousPage()}
                        nextPage={() => nextPage()}
                    />
                );
            case PAGES.INFORMATION_CERTIFICATION_AGREEMENT:
                return (
                    <InformationCertificationAgreementsPage
                        previousPage={() => previousPage()}
                        nextPage={() => nextPage()}
                    />
                );
            case PAGES.CONGRATULATIONS:
                return (
                    <CongratulationsPage
                        previousPage={() => previousPage()}
                    />
                );
        }
    }

    return renderPage();
}

export default CustomerJourney;
